<template>
    <div class="element CheckboxField" :data-required="this.required" :class="error.error ? 'error' : ''"
         :set="resolved_options = resolveOptions()">
        <labelElement v-bind="resolveProps('label', this)" :error="error" />
        <template v-if="this.preview">
            <var>{{ label_string }}</var>
        </template>
        <template v-else-if="Object.keys(resolved_options).length > 5">
            <div ref="dropdown" class="dropdown">
                <button class="btn dropdown-toggle" type="button" @click="handleDropdownClick($event)"
                        :disabled="!this.editing || this.readonly">
                    <span class="title" v-if="!actives.length">{{ trans("Selecteer een ") + this.label }}</span>
                    <span class="title" v-else>{{ formatActives(actives) }}</span>
                </button>
                <div class="dropdown-menu" :class="{open: isDropdownActive}">
                    <div class="Checkbox_container">
                        <div class="Checkbox_element" v-for="(label, id) in resolved_options">
                            <input
                                type="checkbox"
                                class="checkbox"
                                :checked="actives.includes(id)"
                                :class="{'readonly': this.readonly}"
                                :id="`field_${this.id}_${id}`"
                                :name="this.name"
                                :readonly="!this.editing || this.readonly"
                                :autocomplete="this.autocomplete"
                                :value="id"
                                @change="handleChange"
                            />
                            <label class="label" :for="`field_${this.id}_${id}`" :set="custom_option = resolveOptionContent(this.field, label)">
                                <span class="title">
                                    <span class="line1">{{ custom_option?.title ?? label }}</span>
                                    <span class="line2" v-if="custom_option?.text">{{ custom_option.text }}</span>
                                </span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="Checkbox_container" :class="{float: this.float}">
                <div class="Checkbox_element" v-for="(label, id) in resolved_options">
                    <input
                        type="checkbox"
                        class="checkbox"
                        :checked="actives.includes(id)"
                        :class="{'readonly': this.readonly}"
                        :id="`field_${this.id}_${id}`"
                        :name="this.name"
                        :readonly="!this.editing || this.readonly"
                        :autocomplete="this.autocomplete"
                        :value="id"
                    />
                    <label class="label" :for="`field_${this.id}_${id}`" :set="custom_option = resolveOptionContent(this.field, label)">
                        <span class="title">
                            <span class="line1">{{ custom_option?.title ?? label }}</span>
                            <span class="line2" v-if="custom_option?.text">{{ custom_option.text }}</span>
                        </span>
                    </label>
                </div>
            </div>
        </template>
        <div v-if="error.error" class="error">{{ trans(error.message) }}</div>
    </div>
</template>

<script>
import {inject, ref, watch, computed} from "vue";

// Our form helpers
import useFormValidation from "./_validation";
import {propDefaults} from "./_props";

// Our helpers
import {mergeDeep} from "helpers/_objects";

import { formatActives } from "helpers/_formatting";
import trans from "helpers/_translation";

import { resolveProps } from "formbuilder/fields/_props";
import labelElement from "formbuilder/elements/LabelElement.vue";

export default {
    props: mergeDeep(
        propDefaults,
        {
            show_none_option: {type: Boolean, required: false, default: false}
        }
    ),
    components: {
        labelElement
    },
    setup(props) {
        const dropdown = ref();
        const isDropdownActive = ref(false);
        const catchOutsideClick = (e, dropdown) => {
            // When user clicks menu — do nothing
            if (dropdown === e.target || dropdown.contains(e.target)) return false;

            // When user clicks outside of the menu — close the menu
            if (isDropdownActive.value && dropdown !== e.target && !dropdown.contains(e.target)) return true;
        };
        const handleDropdownClick = (e) => {
            isDropdownActive.value = !isDropdownActive.value;
            const closeListener = (e) => {
                if (catchOutsideClick(e, dropdown.value)) {
                    window.removeEventListener('click', closeListener);
                    isDropdownActive.value = false;
                }
            };
            if (isDropdownActive.value) {
                window.addEventListener('click', closeListener);
            } else {
                window.removeEventListener('click', closeListener);
            }
        };

        const actives = ref([]);
        const {error} = useFormValidation();
        // const validateInput = () => {
        //     if (props.required) {
        //         // validateTextField(props.label, input.value);
        //     }
        // };

        const resolveOptionContent = inject("resolveOptionContent");

        const resolveOptions = () => {
            let options = (Object.values(props.options).length ? {...props.options} : JSON.parse(props.options_json || "[]"));
            if (props.show_none_option && !props.required) {
                options = {
                    "": "Geen",
                    ...options
                };
            }
            return options;
        };

        watch(
            () => props.value,
            () => {
                try {
                    actives.value = JSON.parse(props.value) ?? [];
                } catch (e) {
                    // is not a valid JSON string
                    if (Array.isArray(props.value)) {
                        actives.value = props.value;
                    } else {
                        actives.value = [props.value];
                    }
                }
                if (typeof actives.value === 'number') {
                    actives.value = [`${actives.value}`];
                }
            }, {immediate: true}
        );

        const handleChange = (e) => {
            const target = e.currentTarget || e.target;
            if (target.checked) {
                !actives.value.includes(target.value) && actives.value.push(target.value);
            } else {
                actives.value = actives.value.filter(a => a !== target.value);
            }
        };

        const label_string = computed(() => {
            const labels = [];
            actives.value.forEach(a => {
                labels.push(resolveOptions()[a]);
            });
            return labels.join(", ");
        });

        return {
            resolveProps,
            trans,
            dropdown,
            isDropdownActive,
            handleDropdownClick,

            resolveOptions,
            actives,
            error,
            formatActives,
            handleChange,

            label_string,

            resolveOptionContent
        };
    },
}
</script>
